// Libraries
import { Navigate, Outlet } from 'react-router';

// Dependencies
import useManager from 'features/manager/presentation/useManager';

const ManagerRoute = () => {
  const { isManager } = useManager();

  // If the actor is a manager, return an outlet that will render child elements
  // If not, redirect them to the home page instead of rendering manager-only pages
  return isManager ? <Outlet /> : <Navigate to="/" />;
};

export default ManagerRoute;

/* DOCS
To be used like:

<Route element={<ManagerRoute />}> // this wrapper Route will restrict its children Route's to managers only
  <Route path='/admin-dashboard' element={<SuperAdmin />} /> // Pure Route's to be rendered already protected by the parent Route
</Route>

*/
